module.exports = __webpack_public_path__ + "img/1bd9ba3.png";